import { FontFamily } from '@tiptap/extension-font-family';

import { fontFamilyFromStyle, fontFamilyLabel, quoteFontFamily } from './documentContentStyles';

/**
 * Stores font-family with a quoted family name.
 * An unquoted multi-word name is invalid CSS, so the template font shows instead.
 */
export const DocumentFontFamily = FontFamily.extend({
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    fontFamily: {
                        default: null,
                        parseHTML: (element: HTMLElement) =>
                            fontFamilyFromStyle(element.getAttribute('style')),
                        renderHTML: (attributes: { fontFamily?: string | null }) => {
                            if (!attributes.fontFamily || !fontFamilyLabel(attributes.fontFamily)) {
                                return {};
                            }
                            return {
                                style: `font-family: ${quoteFontFamily(attributes.fontFamily)}`,
                            };
                        },
                    },
                },
            },
        ];
    },
});
